import { IActivityWithAvailability } from '@/common/domain/Merge.domain';
import { IDaysAvailability } from '@/common/service/api/Availability/Availability.domain';
import { IActivity } from '@/entities/Activity/domain/Activity.domain';

export const transformActivityToPreview = (
    activity: IActivity & { days_availability?: IDaysAvailability }
): IActivityWithAvailability => {
    const description = JSON.parse(activity.data)
        .text.description.replace(/(<([^>]+)>)/gi, '')
        .replace(/&quot;/g, '"')
        .replace(/&nbsp;/g, '');

    return {
        activity_categories: activity.activity_categories.map((i) => i.id),
        city: {
            name: activity.city_name,
            id: activity.city_id,
        },
        category: {
            id: activity.activity_categories[0]?.id,
            name: activity.activity_categories[0]?.name,
        },
        description: description || activity.description || '',
        duration: activity.duration,
        highlights: '',
        id: activity.id,
        name: activity.name,
        pandemic_meta_data: activity.pandemic_meta_data,
        partner_id: activity.partner_id,
        previewDescription: activity.previewDescription,
        price: activity.price,
        price_strike_out: activity.price_strike_out || null,
        price_strike_out_subunits: activity.price_strike_out_subunits || null,
        price_subunits: activity.price_subunits,
        rate_count: activity.rate_count,
        rating: activity.rating,
        rating_stars: activity.rating_stars,
        reviews: activity.reviews,
        slug: activity.slug,
        special_status: activity.special_status,
        tags: activity.tags,
        title: activity.title,
        trip_noun: activity.trip_noun,
        trip_noun_plural: activity.trip_noun_plural,
        url: activity.url,
        user_images: activity.user_images,
        google: activity.google,
        attributes: '',
    };
};
